import { FilterSelect } from "../components/FilterSelect.jsx";
import { notify } from "../components/Toast.jsx";
import { ClockIcon, CircleCheckBigIcon, FunnelIcon, SearchIcon, CodeIcon, CalendarIcon, ArrowRightIcon, InfoIcon } from "../vendor/runtime.js";
// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import {
  CircleAlertIcon,
  ClipboardCheckIcon,
  ClipboardIcon,
  FileTextIcon,
  LoaderCircleIcon,
  React,
  motion,
} from "../vendor/runtime.js";
import { api } from "../api/client.js";
import { SERVER_URL, RAZORPAY_KEY_ID } from "../config.js";
import { Navbar } from "../components/Navbar.jsx";
import {
  formatRequestDate,
  formatRequestTime,
  requestStatusClasses,
} from "../utils/requestFormatting.js";
import { RequestDetailsModal } from "../components/RequestDetailsModal.jsx";
import { Footer } from "../components/Footer.jsx";
const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    ((script.src = "https://checkout.razorpay.com/v1/checkout.js"),
      (script.onload = () => resolve(true)),
      (script.onerror = () => resolve(false)),
      document.body.appendChild(script));
  });
const RequestsPage = () => {
  const a = useAuth(),
    [n, i] = React.useState([]),
    [l, c] = React.useState(true),
    [u, m] = React.useState(""),
    [f, x] = React.useState(null),
    [p, g] = React.useState(null),
    [payState, setPayState] = React.useState({
      inProgress: false,
      error: null,
    });
  React.useEffect(() => {
    if (a?.loading) return;
    if (!a?.currentUser) {
      c(false);
      return;
    }
    fetchSubmissions();
  }, [a?.currentUser, a?.loading]);
  async function fetchSubmissions() {
    var w;
    (c(true), m(""));
    try {
      const N = await api.get("/requirements/user/my-submissions");
      i(N.data);
    } catch (N) {
      ((w = N.response) == null ? undefined : w.status) === 404
        ? i([])
        : m("Failed to load submissions. Please try again.");
    }
    c(false);
  }
  async function b(id) {
    try {
      await navigator.clipboard.writeText(String(id));
      g(id);
      notify('Request ID copied to your clipboard.', 'success', 'Copied!');
      setTimeout(() => g(null), 2000);
    } catch {
      notify('Please select and copy the request ID manually.', 'error', 'Couldn’t copy request ID');
    }
  }
  async function payForRequest(req) {
    if (!RAZORPAY_KEY_ID) {
      setPayState({ inProgress: false, error: "Payments are temporarily unavailable. Please contact our team for help." });
      return;
    }
    setPayState({ inProgress: true, error: null });
    try {
      const { data } = await api.post(`/requirements/${req.id}/create-order`);
      const order = data.order;
      if (!order || !order.id) {
        setPayState({ inProgress: false, error: "Failed to create payment order" });
        return;
      }
      if (!(await loadRazorpayScript())) {
        setPayState({ inProgress: false, error: "Couldn’t load the payment window. Check your connection and try again." });
        return;
      }
      const options = {
        key: RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency,
        name: "CodeBruh",
        description: req.project_title || req.title,
        order_id: order.id,
        handler: async function (response) {
          try {
            setPayState({ inProgress: true, error: null });
            await api.post("/requirements/verify-payment", {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              requirement_id: req.id,
            });
            setPayState({ inProgress: false, error: null });
            await fetchSubmissions();
            x(null);
            notify("Your payment was verified. Your project files are ready.", "success", "Payment successful");
          } catch (err) {
            console.error("Payment verification error:", err);
            setPayState({
              inProgress: false,
              error: err.response?.data?.error || "Payment verification failed.",
            });
          }
        },
        modal: {
          ondismiss: function () {
            setPayState({ inProgress: false, error: null });
          },
        },
        prefill: {
          name: a?.currentUser?.name || "",
          email: a?.currentUser?.email || "",
          contact: a?.currentUser?.phone || "",
        },
        theme: { color: "#4f46e5" },
      };
      new window.Razorpay(options).open();
    } catch (err) {
      console.error("Payment init error:", err);
      setPayState({
        inProgress: false,
        error: err.response?.data?.error || "Failed to start payment.",
      });
    }
  }
  function downloadRequestFile(req, fileType) {
    window.open(`${SERVER_URL}/api/requirements/${req.id}/download/${fileType}`, "_blank", "noopener,noreferrer");
  }
  const [search, setSearch] = React.useState('');
  const [status, setStatus] = React.useState('all');
  const [theme, setTheme] = React.useState('all');
  const [sort, setSort] = React.useState('newest');
  const normalizedStatus = request => String(request.status || 'unreviewed').toLowerCase();
  const statuses = [...new Set(n.map(normalizedStatus))].sort();
  const themes = [...new Set(n.map(request => request.theme).filter(Boolean))].sort();
  const filtered = n.filter(request => {
    const matchesText = [request.project_title, request.title, request.message, request.id].some(value => String(value || '').toLowerCase().includes(search.trim().toLowerCase()));
    return matchesText && (status === 'all' || normalizedStatus(request) === status) && (theme === 'all' || request.theme === theme);
  }).sort((left, right) => {
    if (sort === 'title') return String(left.project_title || left.title || '').localeCompare(String(right.project_title || right.title || ''));
    return ((Date.parse(left.created_at) || 0) - (Date.parse(right.created_at) || 0)) * (sort === 'oldest' ? 1 : -1);
  });
  const reset = () => { setSearch(''); setStatus('all'); setTheme('all'); setSort('newest'); };
  const hasFilters = search || status !== 'all' || theme !== 'all' || sort !== 'newest';
  const completed = n.filter(request => normalizedStatus(request) === 'completed').length;
  const pendingPayment = n.filter(request => normalizedStatus(request) === 'completed' && request.amount && request.payment_status !== 'paid').length;
  const active = n.filter(request => !['completed', 'rejected', 'cancelled'].includes(normalizedStatus(request))).length;
  return <div className="rq-page"><Navbar />
    <section className="rq-hero">
      <div className="rq-hero-glow rq-hero-glow-one" aria-hidden="true"/>
      <div className="rq-hero-glow rq-hero-glow-two" aria-hidden="true"/>
      <header className="rq-header">
        <div><h1>My Project <span>Requests</span></h1><p>Track your project requests, view updates, and access your completed projects.</p></div>
        {a?.currentUser && <a className="cb-button cb-button-primary" href="/custom-project"><span aria-hidden="true">＋</span> New Request</a>}
      </header>
    </section>
    <main className="rq-main">
      {a?.loading ? <div className="rq-empty" role="status"><LoaderCircleIcon className="animate-spin"/><h2>Loading your workspace…</h2></div> : !a?.currentUser ?
        <div className="rq-empty"><FileTextIcon/><h2>Your projects, in one place</h2><p>Log in to view and track your project requests.</p><a className="cb-button cb-button-primary" href="/login">Log in</a></div> : <>
        <section className="rq-stats" aria-label="Request overview">
          {[[FileTextIcon, 'Total requests', n.length, 'all'], [ClockIcon, 'In progress', active, 'active'], [CircleCheckBigIcon, 'Completed', completed, 'complete'], [CircleAlertIcon, 'Awaiting payment', pendingPayment, 'payment']].map(([Icon, label, count, tone]) =>
            <div className={`rq-stat rq-stat-${tone}`} key={label}><span className="rq-stat-icon"><Icon/></span><div><span>{label}</span><strong>{l || u ? '—' : count}</strong></div></div>)}
        </section>
        <section className="rq-filter-panel" aria-label="Filter requests">
          <div className="rq-filter-heading"><span><FunnelIcon/> Find a request</span><button type="button" disabled={!hasFilters} onClick={reset}>Reset filters</button></div>
          <div className="rq-filters">
            <div className="rq-search"><label htmlFor="request-search">Search requests</label><div><SearchIcon/><input id="request-search" type="search" value={search} onChange={event => setSearch(event.target.value)} placeholder="Search by title or request ID…"/></div></div>
            <div><label>Status</label><FilterSelect label="Status" value={status} onChange={event => setStatus(event.target.value)}><option value="all">All statuses</option>{statuses.map(value => <option key={value} value={value}>{value.replaceAll('_', ' ').replace(/^./, char => char.toUpperCase())}</option>)}</FilterSelect></div>
            <div><label>Project theme</label><FilterSelect label="Project theme" value={theme} onChange={event => setTheme(event.target.value)}><option value="all">All themes</option>{themes.map(value => <option key={value} value={value}>{value}</option>)}</FilterSelect></div>
            <div><label>Sort by</label><FilterSelect label="Sort by" value={sort} onChange={event => setSort(event.target.value)}><option value="newest">Newest first</option><option value="oldest">Oldest first</option><option value="title">Title: A to Z</option></FilterSelect></div>
          </div>
        </section>
        <div className="rq-results-heading"><h2>Your requests <span>{l || u ? '—' : filtered.length}</span></h2><span>{l ? 'Updating your workspace…' : u ? 'Requests unavailable' : `Showing ${filtered.length} of ${n.length} requests`}</span></div>
        {l ? <div className="rq-empty" role="status"><LoaderCircleIcon className="animate-spin"/><h2>Loading your requests…</h2><p>Getting the latest updates for you.</p></div> : u ?
          <div className="rq-inline-alert" role="alert"><CircleAlertIcon/><div><strong>We couldn’t load your requests</strong><p>{u}</p></div><button className="cb-button" onClick={fetchSubmissions}>Try again</button></div> : filtered.length === 0 ?
          <div className="rq-empty"><FileTextIcon/><h2>{n.length ? 'No matching requests' : 'Your next idea starts here'}</h2><p>{n.length ? 'Try another search or clear your filters to see all requests.' : 'Submit your project requirements and track every update in this space.'}</p>{n.length ? <button className="cb-button" onClick={reset}>Clear filters</button> : <a className="cb-button cb-button-primary" href="/custom-project">Create your first request</a>}</div> :
          <div className="rq-grid">{filtered.map(request => <article className="rq-card" key={request.id}>
            <div className="rq-card-top"><span className="rq-project-icon"><CodeIcon/></span><span className={`rq-status rq-status-${normalizedStatus(request).replaceAll('_', '-')}`}><i/>{normalizedStatus(request).replaceAll('_', ' ')}</span></div>
            <div className="rq-theme">{request.theme || 'Custom project'}</div>
            <h3>{request.project_title || request.title || 'Untitled project'}</h3>
            <p className="rq-description">{request.message || 'Open this request to see its details and latest updates.'}</p>
            <div className="rq-card-meta"><CalendarIcon/><span>Submitted {formatRequestDate(request.created_at) || 'recently'}</span></div>
            {normalizedStatus(request) === 'completed' && !!request.amount && <div className={`rq-payment ${request.payment_status === 'paid' ? 'is-paid' : ''}`}><span>{request.payment_status === 'paid' ? 'Paid · Ready to download' : 'Payment pending'}</span><strong>₹{Number(request.amount).toLocaleString('en-IN')}</strong></div>}
            <div className="rq-card-footer"><button type="button" className="rq-copy" onClick={() => b(request.id)} aria-label={`Copy request ID ${request.id}`} title={`Copy request ID: ${request.id}`}><span>#{request.id}</span>{p === request.id ? <ClipboardCheckIcon/> : <ClipboardIcon/>}</button><button type="button" className="rq-view" onClick={() => { setPayState({inProgress: false, error: null}); x(request); }}>View details <ArrowRightIcon/></button></div>
          </article>)}</div>}
        <p className="rq-help"><InfoIcon/>Need a hand with your request? <a href="/contact">Contact our team <ArrowRightIcon/></a></p>
      </>}
      <RequestDetailsModal open={!!f} onClose={() => x(null)} request={f || {}} onPayNow={payForRequest} onDownload={downloadRequestFile} payState={payState}/>
    </main><Footer/>
  </div>;
};
export { RequestsPage };
